module.exports = __webpack_public_path__ + "static/img/news1.a9c0730.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news3/news1.jpg
// module id = gzgI
// module chunks = 1